// @flow

import React from "react";
import classNames from "classnames";

import { ComboBox } from "@components";
import type { OptionType } from "@components";
import PostWidgetChatBubble from "./post-widget-chat-bubble";
import PostWidgetInfoSection from "./post-widget-info-section";

import "./select.scss";

type Props = {
  id?: string,
  name?: string,
  value?: any,
  disabled?: boolean,
  readonly?: boolean,
  autofocus?: boolean,
  required?: boolean,
  rawErrors?: Array<string>,
  className?: string,
  placeholder?: string,
  onChange?: Function,
  options: Object,
  uiSchema?: Object,
  oneOf?: Array<OptionType>,
  withoutPortal?: boolean,
};

export function SelectWidget(props: Props) {
  function handleChange(val: OptionType) {
    props.onChange && props.onChange(val);
  }

  let options = [];
  if (props?.options?.enumOptions) {
    options = props.options.enumOptions.map(opt => {
      return { value: opt.value, label: opt.label };
    });
  } else if (props.oneOf) {
    options = props.oneOf;
  }

  const uiOptions = (props.uiSchema && props.uiSchema["ui:options"]) || props.options || {};
  const shouldHighlightRequired =
    props.required &&
    (!props.value || props.value < 0) &&
    (!props.rawErrors || !props.rawErrors.length);

  return (
    <div
      className={classNames("form-select__container", {
        "form-select__container--disabled": props.disabled,
        "form-input--required": shouldHighlightRequired,
      })}
    >
      <ComboBox
        id={props.id}
        name={props.name}
        onChange={handleChange}
        options={options}
        value={props.value}
        disabled={props.disabled}
        readOnly={props.readonly}
        autoFocus={props.autofocus}
        placeholder={props.placeholder}
        withoutPortal={!!(props.withoutPortal || uiOptions.withoutPortal)}
        className={classNames("mt-1", props.className)}
        asyncOptions={uiOptions.asyncOptions}
        onSelect={uiOptions.onSelect}
      />
      <PostWidgetChatBubble options={props.options} />
      <PostWidgetInfoSection options={props.options} />
    </div>
  );
}

export default SelectWidget;
